import React, { memo } from 'react';
import { createPortal } from 'react-dom';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { motion, AnimatePresence } from 'framer-motion';
import './EmojiPicker.css';
import type { EmojiMartEmoji } from '../utils/whatsappFormatting';

/** Altura aproximada da área de input + margem para o picker ficar acima */
const PICKER_BOTTOM_OFFSET = 72;

interface EmojiPickerProps {
  onEmojiSelect: (emoji: EmojiMartEmoji) => void;
  isOpen: boolean;
  /** Opcional: ref do botão/container do input (não usado para posição; picker fica fixo no bottom centralizado). */
  anchorRef?: React.RefObject<HTMLElement | null>;
}

const EmojiPicker: React.FC<EmojiPickerProps> = ({ onEmojiSelect, isOpen }) => {
  const pickerContent = (
    <AnimatePresence>
      {isOpen && (
        <div
          className="emoji-picker-root"
          style={{
            position: 'fixed',
            bottom: PICKER_BOTTOM_OFFSET,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 10000,
          }}
          aria-hidden={!isOpen}
        >
          <motion.div
            className="emoji-picker-wrapper"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.2 }}
          >
            <div className="emoji-picker-container">
              <Picker
              data={data}
              onEmojiSelect={onEmojiSelect}
              set="native"
              theme="light"
              autoFocus={true}
              icons="solid"
              locale="pt"
              previewPosition="none"
              skinTonePosition="none"
              searchPosition="top"
              navPosition="bottom"
              perLine={8}
              emojiSize={22}
              emojiButtonSize={32}
              maxFrequentRows={1}
              categories={[
                'frequent',
                'people',
                'nature',
                'foods',
                'activity',
                'places',
                'objects',
                'symbols',
                'flags',
              ]}
            />
          </div>
        </motion.div>
        </div>
      )}
    </AnimatePresence>
  );

  if (typeof document !== 'undefined') {
    return createPortal(pickerContent, document.body);
  }

  return pickerContent;
};

export default memo(EmojiPicker);
